import * as XLSX from 'xlsx';

import { IComparableRow } from '../../../types';

const pct = (val: number | null | undefined): string => {
  if (val == null) return '';
  return `${(val * 100).toFixed(0)}%`;
};

const num = (val: number | null | undefined): number | string => {
  if (val == null) return '';
  return val;
};

const str = (val: string | null | undefined): string => val ?? '';

const priceTypeLabel: Record<string, string> = {
  initial:             'Oferta inicial',
  manual:              'Precio manual',
  precio_propietario:  'Precio propietario',
  avaluo:              'Avalúo',
  oferta_inicial:      'Oferta inicial',
  precio_final:        'Precio final',
};

export const exportComparablesToExcel = (rows: IComparableRow[], nid: string): void => {
  const data = rows.map((row, i) => ({
    '#':                        i + 1,
    'Dirección':                str(row.comparable.address),
    'Latitud':                  num(row.comparable.latitude),
    'Longitud':                 num(row.comparable.longitude),
    'Área (m²)':                num(row.comparable.area),
    'Habitaciones':             num(row.comparable.room_num),
    'Baños':                    num(row.comparable.banos),
    'Estacionamiento':          num(row.comparable.garage),
    'Precio normalizado':       num(row.comparable.norm_price),
    'Precio normalizado / m²':  num(row.comparable.norm_price_m2),
    'Fuente':                   str(row.comparable.source_id),
    'Fecha publicación':        str(row.comparable.date_create),
    'Tipo de precio':           priceTypeLabel[row.price_type] ?? str(row.price_type),
    'Vía':                      str(row.price_way),
    'Agente':                   str(row.agente),
    'Percentil':                num(row.percentil),
    'Ask Habi':                 num(row.ask_price_habi),
    'Ask Habi / m²':            num(row.ask_price_habi_m2),
    'Precio manual':            num(row.precio_manual),
    'Precio manual / m²':       num(row.precio_manual_m2),
    'Descuento':                pct(row.discount),
    'Comentario':               str(row.comment),
  }));

  const worksheet = XLSX.utils.json_to_sheet(data);

  // Column widths
  worksheet['!cols'] = [
    { wch: 4 },   // #
    { wch: 36 },  // Dirección
    { wch: 12 },  // Latitud
    { wch: 12 },  // Longitud
    { wch: 10 },  // Área
    { wch: 13 },  // Habitaciones
    { wch: 8 },   // Baños
    { wch: 15 },  // Estacionamiento
    { wch: 20 },  // Precio normalizado
    { wch: 22 },  // Precio normalizado / m²
    { wch: 16 },  // Fuente
    { wch: 18 },  // Fecha publicación
    { wch: 18 },  // Tipo de precio
    { wch: 14 },  // Vía
    { wch: 22 },  // Agente
    { wch: 10 },  // Percentil
    { wch: 16 },  // Ask Habi
    { wch: 16 },  // Ask Habi / m²
    { wch: 16 },  // Precio manual
    { wch: 18 },  // Precio manual / m²
    { wch: 10 },  // Descuento
    { wch: 32 },  // Comentario
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Comparables');

  XLSX.writeFile(workbook, `comparables_${nid}.xlsx`);
};
